module.exports = __webpack_public_path__ + "img/code.debe9b7c.png";